import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noRepository: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	repositories: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noRepository: {
		id: 'project-pages-project-directories.components.view.compass-table.cell.no-repository',
		defaultMessage: 'No repositories',
		description: 'Displayed when a component has no linked repositories.',
	},
	repositories: {
		id: 'project-pages-project-directories.components.view.compass-table.cell.repositories.popup.heading',
		defaultMessage: 'Repositories',
		description: 'Heading of the repositories popup.',
	},
});
export default messages;
